import { CommonModule } from '@angular/common';
import {
    Component,
    EventEmitter,
    Output,
    ChangeDetectionStrategy
} from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslocoModule } from '@jsverse/transloco';
import { LanguagesService } from '../../../../core/services/languages.service';
import { Language } from '../../../../domain/models';

@Component({
    selector: 'app-preferred-language',
    templateUrl: './preferred-language.component.html',
    styleUrls: ['./preferred-language.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslocoModule,
        CommonModule,
        MatIconModule,
        FlexLayoutModule,
        MatButtonModule,
        MatMenuModule
    ]
})
export class PreferredLanguageComponent {
    @Output() language = new EventEmitter<Language>();

    languages$ = this._languages.languages$;

    constructor(private readonly _languages: LanguagesService) {}

    chooseLanguage(language: Language) {
        this.language.next(language);
    }
}
